/*
 * @Author: LiuChuanQi
 * @Date: 2022-11-11 15:37:51
 * @LastEditTime: 2023-03-03 20:53:56
 * @LastEditors: LiuChuanQi
 * @Description: 页面滚动条滚动到顶部
 * @FilePath: \speedtest-bigdata-v2\src\utils\hooks\scrollTop.js
 * 
 */
export const scrollTop = function () {
  let timer = null
  timer = setInterval(function () {
    if (document.documentElement.scrollTop <= 0) {
      clearInterval(timer)
    } else {
      document.documentElement.scrollTop = 0
    }
  }, 50)
}